<app-landing-background>
  <router-outlet></router-outlet>

  <app-image-preview />
  <app-error-popup [message]="notify.error$ | async" [title]="notify.errorTitle$ | async" [download]="notify.errorDownload$ | async"></app-error-popup>
  <app-info-popup [message]="notify.info$ | async" [title]="notify.infoTitle$ | async"></app-info-popup>
  <app-snackbar [message]="notify.success$ | async"></app-snackbar>

  @if (loadingService.isLoading$ | async) {
    <div class="global-loader-overlay" aria-live="polite" aria-busy="true">
      <div class="global-loader" role="status" aria-label="Loading">
        <div class="global-loader-orbit" aria-hidden="true"></div>
        <img src="/azrieli.png" alt="" class="global-loader-logo" width="48" height="48" />
      </div>
    </div>
  }
</app-landing-background>

